<template>
	<GridLayout
		v-if="organization"
		:sidebar-state="false"
		:reactive-sidebar="false"
		right-title="ORGANIZAÇÃO"
		:back-action="() => $router.push({ name: 'Organizations' })"
	>
		<template #right-content>
			<ToolBar>
				<div
					id="tab-list"
					class="h-full flex-1 justify-center"
				>
					<a
						v-if="HasRole(49)"
						class="tab-item"
						:class="{
							active: selectedTab === 'register_obligations',
						}"
						@click="SelectTab('register_obligations')"
						>CADASTRO
					</a>
					<a
						v-if="HasRole(23)"
						class="tab-item"
						:class="{
							active: selectedTab === 'employees',
						}"
						@click="SelectTab('employees')"
						>COLABORADORES
					</a>
					<a
						v-if="HasRole(22)"
						class="tab-item"
						:class="{
							active: selectedTab === 'data',
						}"
						@click="SelectTab('data')"
						>DADOS
					</a>
					<a
						v-if="HasRole(48)"
						class="tab-item"
						:class="{
							active: selectedTab === 'guides',
						}"
						@click="SelectTab('guides')"
						>GUIAS
					</a>
					<a
						v-if="HasRole(25)"
						class="tab-item"
						:class="{
							active: selectedTab === 'scheduling_instructions',
						}"
						@click="SelectTab('scheduling_instructions')"
					>
						INSTRUÇÕES DE AGENDAMENTO
					</a>
					<a
						v-if="HasRole(34)"
						class="tab-item"
						:class="{
							active: selectedTab === 'options',
						}"
						@click="SelectTab('options')"
					>
						OPÇÕES
					</a>
					<a
						v-if="HasRole(28)"
						class="tab-item"
						:class="{
							active: selectedTab === 'letterhead',
						}"
						@click="SelectTab('letterhead')"
					>
						PAPEL TIMBRADO
					</a>
					<a
						v-if="HasRole(24)"
						class="tab-item"
						:class="{
							active: selectedTab === 'profiles',
						}"
						@click="SelectTab('profiles')"
					>
						PERFIS
					</a>
					<a
						v-if="HasRole(36)"
						class="tab-item"
						:class="{
							active: selectedTab === 'proceedings',
						}"
						@click="SelectTab('proceedings')"
					>
						PROCEDIMENTOS
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedTab === 'indicator',
						}"
						@click="SelectTab('indicator')"
					>
						SOLICITANTE
					</a>
					<a
						v-if="HasRole(26)"
						class="tab-item"
						:class="{
							active: selectedTab === 'status',
						}"
						@click="SelectTab('status')"
					>
						STATUS
					</a>
					<a
						v-if="HasRole(27)"
						class="tab-item"
						:class="{
							active: selectedTab === 'templates',
						}"
						@click="SelectTab('templates')"
					>
						TEMPLATES
					</a>
				</div>
			</ToolBar>

			<MainContent>
				<Identification :organization="organization" />

				<div class="w-full py-3">
					<RegisterObligations
						v-if="HasRole(49) && selectedTab === 'register_obligations'"
						ref="register_obligations"
						:organization="organization"
						@refresh="
							GetAuthAccount()
							GetOrganizationData()
						"
					/>

					<Employees
						v-if="HasRole(23) && selectedTab === 'employees'"
						:permission="HasRole(23)"
						:providers="providers"
						:subscription="subscription"
						:organization_id="organization_id"
						@refresh="GetOrganizationData"
					/>

					<OrganizationForm
						v-if="HasRole(22) && selectedTab === 'data'"
						ref="organization_form"
						class="px-4"
						:is_registered="is_registered"
						:organization="organization"
						:organization_id="organization_id"
						@submit="SaveOrganizationData"
					/>

					<Guides
						v-if="HasRole(48) && selectedTab === 'guides'"
						:organization="organization"
					/>

					<Instructions
						v-if="HasRole(25) && selectedTab === 'scheduling_instructions'"
						ref="scheduling_instructions"
						:config_id="organization?.instances[0]?.config?.id"
					/>

					<Options
						v-if="HasRole(34) && selectedTab === 'options'"
						:organization="organization"
					/>

					<Letterhead
						v-if="HasRole(28) && selectedTab === 'letterhead' && organization?.instances[0]?.config"
						ref="letterhead"
						:organization_id="organization_id"
						:logo="organization.instances[0].config.logo_url"
						:footer_sup="organization.instances[0].config.rodape_sup"
						:footer_inf="organization.instances[0].config.rodape_inf"
					/>

					<Profiles
						v-if="HasRole(24) && selectedTab === 'profiles'"
						:organization_id="organization_id"
					/>

					<Proceedings
						v-if="HasRole(36) && selectedTab === 'proceedings'"
						:permission="HasRole(36)"
						:can_modify="HasRole(36)"
						:organization="organization"
					/>

					<Indicators
						v-if="selectedTab === 'indicator'"
						:organization_id="organization_id"
					/>

					<div
						v-if="HasRole(26) && selectedTab === 'status'"
						class="py-5 max-500 text-center mx-auto"
					>
						<h3 class="font-24 mb-5">
							VOCÊ PODE DESATIVAR E REATIVAR TEMPORARIAMENTE ESTA ORGANIZAÇÃO SEMPRE QUE PRECISAR.
						</h3>
					</div>

					<Templates
						v-if="HasRole(27) && selectedTab === 'templates'"
						:permission="HasRole(27)"
						:can_modify="HasRole(31)"
						:providers="providers"
						:organization="organization"
						@refresh-organization="GetOrganizationData"
					/>
				</div>
			</MainContent>
		</template>
		<template #right-footer>
			<div class="w-full h-full flex justify-between">
				<button
					class="btn btn-danger btn-fixed-size"
					:disabled="cancelButtonDisabled"
					@click="Cancel"
				>
					{{ cancelButtonLabel }}
				</button>
				<button
					class="btn btn-success btn-fixed-size"
					:disabled="finishButtonDisabled"
					@click="Continue"
				>
					{{ finishButtonLabel }}
				</button>
			</div>
		</template>
	</GridLayout>
</template>

<script>
	const _ = require('lodash')
	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'

	import { useConfirmation, useError } from '@/composables'

	import Letterhead from './components/Letterhead'
	import Employees from './components/Employees'
	import Guides from './components/guides/Guides'
	import Identification from './components/Identification'
	import Indicators from './components/Indicators'
	import Instructions from './components/Instructions'
	import Options from './components/Options'
	import OrganizationForm from './components/OrganizationForm'
	import Places from './components/Places'
	import Proceedings from './components/Proceedings'
	import Profiles from './components/Profiles'
	import RegisterObligations from './components/RegisterObligations'
	import Templates from './components/templates/Templates'

	export default {
		name: 'Panel',
		props: {
			organization_id: {
				type: [String, Number],
				required: true,
				default: null,
			},
		},
		components: {
			Letterhead,
			Employees,
			Guides,
			Identification,
			Indicators,
			Instructions,
			Options,
			OrganizationForm,
			Places,
			Proceedings,
			Profiles,
			RegisterObligations,
			Templates,
		},
		data() {
			return {
				organization: null,
				providers: [],
				subscription: null,
				user_roles: [],
				native_profiles: [],
				days_left: 0,
				selectedTab: 'register_obligations',
			}
		},
		computed: {
			...mapGetters('auth', ['account', 'all_roles', 'requester_selected_id', 'is_registered']),
			is_personal_org() {
				return this.organization.created_by === 2 // 1 = CRIADO PELO USUÁRIO | 2 = CRIADO PELO INSTANT
			},
			cancelButtonLabel() {
				let label = 'CANCELAR'

				switch (this.selectedTab) {
					case 'status':
						label = 'DESATIVAR'
						break
				}

				return label
			},
			cancelButtonDisabled() {
				let shouldDisable = false

				switch (this.selectedTab) {
					case 'status':
						shouldDisable = !this.organization.status
						break
					default:
						shouldDisable = true
						break
				}

				return shouldDisable
			},
			finishButtonLabel() {
				let label = 'SALVAR'

				switch (this.selectedTab) {
					case 'register_obligations':
					case 'data':
					case 'letterhead':
					case 'scheduling_instructions':
						label = 'SALVAR'
						break
					case 'status':
						label = 'REATIVAR'
						break
				}

				return label
			},
			finishButtonDisabled() {
				let shouldDisable = false

				switch (this.selectedTab) {
					case 'register_obligations':
					case 'data':
					case 'letterhead':
					case 'scheduling_instructions':
						shouldDisable = false
						break
					case 'status':
						shouldDisable = this.organization.status
						break
					default:
						shouldDisable = true
						break
				}

				return shouldDisable
			},
		},
		watch: {
			all_roles: {
				handler(val) {
					if (this.organization_id) {
						this.user_roles = _.orderBy(val[`${this.organization_id}`], 'asc')

						this.$nextTick(() => {
							this.BindTabsAutoCenter()
							this.CenterActiveTab()
						})
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			...mapActions('auth', ['GetAuthAccount']),
			SelectTab(tab) {
				this.selectedTab = tab
			},
			Cancel() {
				switch (this.selectedTab) {
					case 'status':
						this.ToggleOrganizationStatus()
						break
				}
			},
			Continue() {
				switch (this.selectedTab) {
					case 'register_obligations':
						this.$refs.register_obligations.SaveRegisterObligations()
						break
					case 'data':
						this.$refs.organization_form.Validate()
						break
					case 'letterhead':
						this.$refs.letterhead.SaveFooter()
						break
					case 'scheduling_instructions':
						this.$refs.scheduling_instructions.Save()
						break
					case 'status':
						this.ToggleOrganizationStatus()
						break
				}
			},
			GetOrganizationData(loading_spinner = true) {
				if (loading_spinner) this.StartLoading()

				return window.api
					.call('post', '/get-organization-management', {
						account_id: this.organization_id,
					})
					.then(async ({ data }) => {
						if (!data.response) {
							useError('VOCÊ NÃO POSSUI PERMISSÃO!')

							this.$router.push({ name: 'Organizations' })
							return
						}

						this.organization = data.organization
						this.providers = data.organization.provider
						this.subscription = data.organization.subscription
						this.proceedings = data.organization.proceedings

						this.$nextTick(() => {
							this.BindTabsAutoCenter()
							this.CenterActiveTab()
						})
					})
					.finally(() => {
						if (loading_spinner) this.FinishLoading()
					})
			},
			ToggleOrganizationStatus() {
				if (this.organization_id === this.requester_selected_id) {
					useError('PARA ALTERAR O STATUS É NECESSÁRIO ESTAR LOGADO EM OUTRA CONTA.')
					return
				}

				Swal.fire({
					icon: 'warning',
					title: 'ATENÇÃO!',
					html: `Se desativar a organização a seção de Financeiro e pagamentos do seu Plano serão impactados!<br>Realmente deseja ${
						this.organization.status ? 'des' : 're'
					}ativar?`,
					showCancelButton: true,
					confirmButtonColor: this.organization.status ? '#F64E60' : '#20C964',
					confirmButtonText: `Sim, ${this.organization.status ? 'des' : 're'}ativar`,
					cancelButtonText: 'Cancelar',
				}).then(result => {
					if (result.isConfirmed) {
						this.StartLoading()

						return window.api
							.call('post', '/toggle-organization-status', {
								account_id: this.organization_id,
							})
							.then(({ data }) => {
								if (!data.response) {
									useError('HOUVE UM ERRO AO CONCLUIR, CONTATE O SUPORTE')
									return
								}

								this.organization.status = data.status
								useConfirmation()
							})
							.finally(() => {
								this.FinishLoading()
								this.GetAuthAccount()
							})
					}
				})
			},
			async SaveOrganizationData(form) {
				const vm = this

				vm.StartLoading()

				return window.api
					.call('post', '/save-organization', {
						account_id: vm.organization_id,
						...form,
					})
					.then(async ({ data }) => {
						if (!data.response) {
							useError('HOUVE UM ERRO AO CONCLUIR, CONTATE O SUPORTE')
							return
						}

						const mustRedirectToMessages = this.$refs.organization_form.messages_missing_data

						await this.GetOrganizationData()

						if (!mustRedirectToMessages) {
							useConfirmation()
						} else {
							this.RedirectToMessagesHandler()
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			async IsRegistered() {
				const vm = this

				vm.StartLoading()

				return await window.api
					.call('post', '/gateway/is-registered', {
						organization_id: vm.organization_id,
					})
					.then(({ data }) => {
						vm.is_registered = data.response
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			HasRole(role) {
				return this.user_roles && this.user_roles.indexOf(parseInt(role)) > -1
			},
			ToggleBlock(block) {
				const refs = Object.keys(this.$refs)

				for (let key in refs) {
					const tab = refs[key]

					if (tab != 'data') {
						if (block) {
							this.$refs[tab].classList.add('d-none')
						} else {
							this.$refs[tab].classList.remove('d-none')
						}
					}
				}
			},
			CenterActiveTab(smooth = false) {
				const tabsScroll = this.$refs.tabsScroll

				if (!tabsScroll) return

				const activeTab = tabsScroll.querySelector('.nav-link.active')

				if (!activeTab) return

				this.CenterTabElement(activeTab, smooth)
			},
			CenterTabElement(tabElement, smooth = false) {
				const tabsScroll = this.$refs.tabsScroll

				if (!tabsScroll || !tabElement) return

				tabElement.scrollIntoView({
					behavior: smooth ? 'smooth' : 'auto',
					inline: 'center',
					block: 'nearest',
				})
			},
			HandleTabsInteraction(event) {
				const tabLink = event.target.closest('.nav-link[data-toggle="tab"]')

				if (!tabLink) return

				this.CenterTabElement(tabLink, true)
			},
			HandleTabShown(event) {
				if (!event || !event.target) return

				this.$nextTick(() => {
					this.CenterTabElement(event.target, true)
				})
			},
			HandleResize() {
				this.$nextTick(() => {
					this.CenterActiveTab()
				})
			},
			BindTabsAutoCenter() {
				const tabsScroll = this.$refs.tabsScroll

				if (!tabsScroll) return

				this.UnbindTabsAutoCenter()
				tabsScroll.addEventListener('click', this.HandleTabsInteraction)
				tabsScroll.addEventListener('shown.bs.tab', this.HandleTabShown)
			},
			UnbindTabsAutoCenter() {
				const tabsScroll = this.$refs.tabsScroll

				if (!tabsScroll) return

				tabsScroll.removeEventListener('click', this.HandleTabsInteraction)
				tabsScroll.removeEventListener('shown.bs.tab', this.HandleTabShown)
			},
			SelectDefaultTabByPermissions() {
				if (this.is_personal_org) {
					this.selectedTab = 'letterhead'
					return
				}

				this.selectedTab = 'register_obligations'
			},
		},
		beforeMount() {
			this.GetOrganizationData()
		},
		mounted() {
			this.$nextTick(() => {
				this.BindTabsAutoCenter()
				this.CenterActiveTab()
			})

			window.addEventListener('resize', this.HandleResize)
		},
		beforeUnmount() {
			this.UnbindTabsAutoCenter()
			window.removeEventListener('resize', this.HandleResize)
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 !important;
		width: 100%;
		max-width: 100%;
	}

	.organization-tabs-scroll {
		overflow-x: auto;
		overflow-y: hidden;
	}

	.organization-tabs-list {
		flex-wrap: wrap;
		min-width: max-content;
	}

	.swal-modal .swal-text {
		text-align: left !important;
	}
</style>
